"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvitationList = undefined;

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvitationList = exports.InvitationList = function (_Component) {
  (0, _inherits3.default)(InvitationList, _Component);

  function InvitationList(props) {
    (0, _classCallCheck3.default)(this, InvitationList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InvitationList.__proto__ || (0, _getPrototypeOf2.default)(InvitationList)).call(this, props));

    _this.state = {};
    _this.state.filterText = "";
    _this.state.showHeaders = false;
    _this.state.readyToSend = false;
    _this.state.invitations = [];
    return _this;
  }

  (0, _createClass3.default)(InvitationList, [{
    key: "handleUserInput",
    value: function handleUserInput(filterText) {
      this.setState({ filterText: filterText });
    }
  }, {
    key: "handleRowDel",
    value: function handleRowDel(invitation) {
      var index = this.state.invitations.indexOf(invitation);
      this.state.invitations.splice(index, 1);
      this.setState(this.state.invitations);
      if ((0, _keys2.default)(this.state.invitations).length == 0) {
        this.setState({ readyToSend: false });
      }
    }
  }, {
    key: "handleAddEvent",
    value: function handleAddEvent(evt) {
      var id = (+new Date() + Math.floor(Math.random() * 999999)).toString(36);
      var invitation = {
        id: id,
        user_name: "",
        phone: "",
        email: ""
      };
      this.state.invitations.push(invitation);

      this.setState(this.state.invitations);
      this.setState({ readyToSend: true });
    }
  }, {
    key: "handleTable",
    value: function handleTable(evt) {
      var item = {
        id: evt.target.id,
        name: evt.target.name,
        value: evt.target.value
      };
      var invitations = this.state.invitations.slice();
      var newInvitations = invitations.map(function (invitation) {
        for (var key in invitation) {
          if (key == item.name && invitation.id == item.id) {
            invitation[key] = item.value;
          }
        }
        return invitation;
      });
      this.setState({ invitations: newInvitations });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        this.renderInvitationListTable(),
        this.renderSendButton()
      );
    }
  }, {
    key: "renderInvitationListTable",
    value: function renderInvitationListTable() {
      if (this.state) {
        return _react2.default.createElement(InvitationListTable, {
          onInvitationTableUpdate: this.handleTable.bind(this),
          onRowAdd: this.handleAddEvent.bind(this),
          onRowDel: this.handleRowDel.bind(this),
          invitations: this.state.invitations,
          filterText: this.state.filterText
        });
      }
    }
  }, {
    key: "renderSendButton",
    value: function renderSendButton() {
      if (this.state) {
        if (this.state.readyToSend) {
          return _react2.default.createElement(_Button2.default, {
            text: "L\xE4het\xE4",
            additionalClasses: "button-set-width",
            onClick: this.handleSendButtonClick.bind(this)
          });
        }
      }
    }
  }, {
    key: "sendOneInvitation",
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.sendDriverLicenseInvitation(data);

              case 2:
                response = _context.sent;

                console.info("TODO response handling", response);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendOneInvitation(_x) {
        return _ref.apply(this, arguments);
      }

      return sendOneInvitation;
    }()
  }, {
    key: "handleSendButtonClick",
    value: function handleSendButtonClick() {
      var data = {};

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.state.invitations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var invitation = _step.value;

          data = {
            sender_user_id: this.props.sender.id,
            sender_company_id: Number(this.props.sender.company_id),
            receiver_email: invitation.email,
            sender_email: this.props.sender.email,
            receiver_phone: invitation.phone,
            receiver_name: invitation.user_name,
            invitation_token: this.props.token,
            license_order_id: this.props.orderId
          };
          this.sendOneInvitation(data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.setState({ invitations: [] });
    }
  }]);
  return InvitationList;
}(_react.Component);

var SearchBar = function (_Component2) {
  (0, _inherits3.default)(SearchBar, _Component2);

  function SearchBar() {
    (0, _classCallCheck3.default)(this, SearchBar);
    return (0, _possibleConstructorReturn3.default)(this, (SearchBar.__proto__ || (0, _getPrototypeOf2.default)(SearchBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(SearchBar, [{
    key: "handleChange",
    value: function handleChange() {
      this.props.onUserInput(this.refs.filterTextInput.value);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement("input", {
          type: "text",
          placeholder: "Etsi...",
          value: this.props.filterText,
          ref: "filterTextInput",
          onChange: this.handleChange.bind(this)
        })
      );
    }
  }]);
  return SearchBar;
}(_react.Component);

var InvitationListTable = function (_Component3) {
  (0, _inherits3.default)(InvitationListTable, _Component3);

  function InvitationListTable() {
    (0, _classCallCheck3.default)(this, InvitationListTable);
    return (0, _possibleConstructorReturn3.default)(this, (InvitationListTable.__proto__ || (0, _getPrototypeOf2.default)(InvitationListTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(InvitationListTable, [{
    key: "render",
    value: function render() {
      var invitations = this.props.invitations;

      var hasItems = (0, _keys2.default)(invitations).length;

      var onInvitationTableUpdate = this.props.onInvitationTableUpdate;
      var rowDel = this.props.onRowDel;
      var filterText = this.props.filterText;
      var invitation = this.props.invitations.map(function (invitation) {
        if (invitation.email.indexOf(filterText) === -1) {
          return;
        }
        return _react2.default.createElement(InvitationListRow, {
          onInvitationTableUpdate: onInvitationTableUpdate,
          invitation: invitation,
          onDelEvent: rowDel.bind(this),
          key: invitation.id
        });
      });
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "button",
          {
            type: "button",
            onClick: this.props.onRowAdd,
            className: "btn btn-success pull-right"
          },
          "Lis\xE4\xE4"
        ),
        _react2.default.createElement(
          "table",
          { className: "table table-bordered" },
          hasItems > 0 && _react2.default.createElement(
            "thead",
            null,
            _react2.default.createElement(
              "tr",
              null,
              _react2.default.createElement(
                "th",
                null,
                "Nimi"
              ),
              _react2.default.createElement(
                "th",
                null,
                "Puhelinnumero"
              ),
              _react2.default.createElement(
                "th",
                null,
                "S\xE4hk\xF6postiosoite"
              )
            )
          ),
          _react2.default.createElement(
            "tbody",
            null,
            invitation
          )
        )
      );
    }
  }]);
  return InvitationListTable;
}(_react.Component);

var InvitationListRow = function (_Component4) {
  (0, _inherits3.default)(InvitationListRow, _Component4);

  function InvitationListRow() {
    (0, _classCallCheck3.default)(this, InvitationListRow);
    return (0, _possibleConstructorReturn3.default)(this, (InvitationListRow.__proto__ || (0, _getPrototypeOf2.default)(InvitationListRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(InvitationListRow, [{
    key: "onDelEvent",
    value: function onDelEvent() {
      this.props.onDelEvent(this.props.invitation);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "tr",
        { className: "eachRow" },
        _react2.default.createElement(EditableTextCell, {
          onInvitationTableUpdate: this.props.onInvitationTableUpdate,
          cellData: {
            type: "user_name",
            value: this.props.invitation.user_name,
            id: this.props.invitation.id
          }
        }),
        _react2.default.createElement(EditableTextCell, {
          onInvitationTableUpdate: this.props.onInvitationTableUpdate,
          cellData: {
            type: "phone",
            value: this.props.invitation.phone,
            id: this.props.invitation.id
          }
        }),
        _react2.default.createElement(EditableTextCell, {
          onInvitationTableUpdate: this.props.onInvitationTableUpdate,
          cellData: {
            type: "email",
            value: this.props.invitation.email,
            id: this.props.invitation.id
          }
        }),
        _react2.default.createElement(
          "td",
          { className: "del-cell" },
          _react2.default.createElement("input", {
            type: "button",
            onClick: this.onDelEvent.bind(this),
            value: "X",
            className: "del-btn"
          })
        )
      );
    }
  }]);
  return InvitationListRow;
}(_react.Component);

var EditableTextCell = function (_Component5) {
  (0, _inherits3.default)(EditableTextCell, _Component5);

  function EditableTextCell() {
    (0, _classCallCheck3.default)(this, EditableTextCell);
    return (0, _possibleConstructorReturn3.default)(this, (EditableTextCell.__proto__ || (0, _getPrototypeOf2.default)(EditableTextCell)).apply(this, arguments));
  }

  (0, _createClass3.default)(EditableTextCell, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "td",
        null,
        _react2.default.createElement("input", {
          type: "text",
          name: this.props.cellData.type,
          id: this.props.cellData.id,
          value: this.props.cellData.value,
          onChange: this.props.onInvitationTableUpdate
        })
      );
    }
  }]);
  return EditableTextCell;
}(_react.Component);

var EditableNumberCell = function (_Component6) {
  (0, _inherits3.default)(EditableNumberCell, _Component6);

  function EditableNumberCell() {
    (0, _classCallCheck3.default)(this, EditableNumberCell);
    return (0, _possibleConstructorReturn3.default)(this, (EditableNumberCell.__proto__ || (0, _getPrototypeOf2.default)(EditableNumberCell)).apply(this, arguments));
  }

  (0, _createClass3.default)(EditableNumberCell, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "td",
        null,
        _react2.default.createElement("input", {
          type: "number",
          name: this.props.cellData.type,
          id: this.props.cellData.id,
          value: this.props.cellData.value,
          onChange: this.props.onInvitationTableUpdate
        })
      );
    }
  }]);
  return EditableNumberCell;
}(_react.Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/license/InvitationList.js
 ** module id = 1151
 ** module chunks = 0
 **/